import { PaletteOptions } from '@mui/material'
import { muiConfig } from '@rent/ui/config'

const colors: PaletteOptions = {
  ...muiConfig.colors,
  primary: {
    main: '#2189ff',
  },
  secondary: {
    main: '#000000',
  },
  text: {
    primary: '#000',
    secondary: '#787878',
    disabled: '#928f8f',
  },
}

export { colors }
